import {createAsyncThunk} from '@reduxjs/toolkit'
import getErrorContext from 'modules/analytics/contexts/getErrorContext'
import {trackBookingError} from 'modules/analytics/paymentPageTracking'
import {bookOfferFinalizationError} from 'modules/book/actions/bookOfferFinalization'
import {bookOfferCreationError} from 'modules/book/slice'
import {RejectResponseType} from 'types/errorResponse'
import {getCurrentBookingRequestId} from 'utils/bookingRequestId'
import {getMerchantOfRecordCode} from 'utils/getMerchantOfRecordCode'

import {getDevicePlatform} from '@vio/core/src/_web/utils/userAgent/device'

import {RootState} from '../../../store'
import {getUnifiedOfferCheck} from '../../offerCheck/selectors'
import {getRedirectContext} from '../selectors'
import {setError} from '../slice'

export interface HandleBookingErrorArg {
  /** The error in RejectResponseType format. Callers must normalize before dispatching. */
  error: RejectResponseType
  /** Whether this error occurred during the finalization phase (affects which legacy action is dispatched) */
  isFinalization?: boolean
  /** Only emit `booking errored`, the request failed, not the booking, whose outcome stays unknown. */
  trackOnly?: boolean
}

export const handleBookingError = createAsyncThunk<
  void,
  HandleBookingErrorArg,
  {state: RootState}
>('bookingCreation/handleBookingError', async (arg, {dispatch, getState}) => {
  const {error: rejectResponse, isFinalization = false, trackOnly = false} = arg
  const state = getState()

  if (!trackOnly) {
    dispatch(setError())

    dispatch(
      isFinalization
        ? bookOfferFinalizationError(rejectResponse)
        : bookOfferCreationError(rejectResponse)
    )
  }

  const {merchantOfRecord, providerCode} =
    getUnifiedOfferCheck(state).data || {}

  trackBookingError({
    bookingRequestId: getCurrentBookingRequestId(),
    merchantOfRecordCode: getMerchantOfRecordCode(
      merchantOfRecord,
      providerCode
    ),
    errorContext: getErrorContext(rejectResponse.data, rejectResponse.status),
    dispatch,
    platform: getDevicePlatform(),
    paymentMethod: getRedirectContext(state)?.paymentMethodType
  })
})
